import Logo from 'assets/general/Logo_BMI_Geo_Risk_Signals_White.svg';

const NoGQPermissions = () => {
    return (
        <div className="preload-error">
            <div className="preload-error-logo">
                <img src={Logo} alt="" />
            </div>
            <div>You do not have access to BMI Geo Risk Signals.</div>
        </div>
    );
};

export default NoGQPermissions